export default "__VITE_ASSET__BgVA53Hj__"